import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'
import TourItinerarySection from '../../sections/CommonSection/TourItinerarySection'
import { delhiAgraJaipurData } from './tourPackageData'

const DelhiAgraJaipur = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Delhi - Agra - Jaipur" />
            <CommonBreadcrumb items={["Delhi - Agra - Jaipur"]} />
            <TourItinerarySection {...delhiAgraJaipurData} />
            <Footer />
        </>
    )
}

export default DelhiAgraJaipur